import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from './contexts/ToastContext';
import { ThemeProvider } from './components/ThemeProvider';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './providers/NotificationProvider';
import App from './App';
import './index.css';
import '../../../config/ui/theme/theme-styles.css';

// Stop wheel events on focused number inputs from scrolling the parent container
document.addEventListener('wheel', (e) => {
  const target = e.target as HTMLElement;
  if (target.tagName === 'INPUT' && (target as HTMLInputElement).type === 'number' && target === document.activeElement) {
    e.stopPropagation();
  }
}, { capture: true });

// Create a query client instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* On React Router v7: startTransition and relative splat paths are the
          defaults, so the former v6 future flags are no longer needed. */}
      <BrowserRouter>
        <ThemeProvider defaultMode="system">
          <ToastProvider logoSrc="/icons/HighCallRodeo-icon-white.png">
            <AuthProvider>
              <NotificationProvider>
                <App />
              </NotificationProvider>
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);